<template>
<div>
    <b-link
        :to="{name: 'accessibleData'}"
        class="accessible-link"
    >
        {{$t('showDetailsOfAllResults')}}
    </b-link>
    <div
        v-for="(group, groupIndex) in groups"
        :key="`tab_${group.id}`"
        class="mt-4"
    >
        <h2>{{ group.title }} <span>({{group.count}})</span></h2>
        <b-link
            class="accessible-link"
            v-if="groups.length > 1"
        >
            {{$t('showDetailsOfAllResultsOfGroup')}}
        </b-link>
        <feature-info-list-table
            v-if="group.count > 0"
            :group="group"
            :groupIndex="groupIndex"
        />
    </div>
</div>
</template>

<script>
    import FeatureInfoListTable from '../../information/selection/FeatureInfoListTable.vue';

    export default {
        props: {
            groups: { type: Array, required: true },
            objects: { type: Array, required: true },
        },
        components: { 'feature-info-list-table': FeatureInfoListTable }
    };
</script>
